/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Orders_CancelledInputs */

const vi_report_orders_cancelled = /** @type {(inputs: Report_Orders_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã hủy`)
};

/**

* @param {Report_Orders_CancelledInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_orders_cancelled = /** @type {((inputs?: Report_Orders_CancelledInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Orders_CancelledInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_orders_cancelled(inputs)
});